import React from "react";
import './index.module.css'

const Medications = () => {
  // Initialize dummy data for medications and allergies
  const medications = [
    {
      medication: "Medication 1",
      quantity: "2 tablets",
      frequency: "Twice a day",
      status: "Active",
      fileURL: "https://example.com/prescription1.pdf",
    },
    {
      medication: "Medication 2",
      quantity: "1 tablet",
      frequency: "Once a day",
      status: "Inactive",
      fileURL: "",
    },
    // Add more medication records as needed
  ];

  const allergies = [
    {
      allergyName: "Allergy 1",
      reaction: "Skin rash",
      status: "Active",
    },
    {
      allergyName: "Allergy 2",
      reaction: "Difficulty breathing",
      status: "Inactive",
    },
    // Add more allergy records as needed
  ];

  return (
    <div className="main-container">
      <div className="sub-container-row">
        <div className="am-table-container">
          <div className="table-header">
            <span>Medications</span>

            {/* <img
              src={require("../../../../../../assets/RpmAssets/PNGIcons/more.png")}
              alt=""
            /> */}
          </div>

          <table>
            <tr>
              <th>Medicine Name</th>
              <th>Quantity</th>
              <th>Frequency</th>
              <th colSpan={3}>Status</th>
              <th colSpan={2}>File</th>
            </tr>

            <tbody>
              {medications != undefined && medications.length > 0 ? (
                medications.map((element, key) => {
                  //if()
                  return (
                    <tr>
                      <td>{element.medication}</td>
                      <td>{element.quantity} </td>

                      <td colSpan={2}>{element.frequency}</td>

                      <td>{element.status}</td>
                      <td></td>
                      <td>
                        {element.fileURL != undefined &&
                        element.fileURL != "" ? (
                          <>
                            <a href={element.fileURL} target="_blank">
                              Prescription
                            </a>
                          </>
                        ) : (
                          <>
                            <span>-</span>
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5}>
                    <div className="no-data">
                      {/* <img
                          src={require("../../../../../../assets/RpmAssets/PNGIcons/no_medicines.png")}
                          alt=""
                        /> */}

                      <span>No data available</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="am-table-container">
          <div className="table-header">
            <span>Allergies</span>

            {/* <img onClick={addNewRowInAllergies} src={require('../../../../../../assets/RpmAssets/PNGIcons/more.png')} alt="" /> */}
          </div>

          <table>
            <tr>
              <th>Allergen</th>
              <th colSpan={2}>Reactions</th>
              <th>Status</th>
              <th></th>
            </tr>

            <tbody>
              {allergies != undefined && allergies.length > 0 ? (
                allergies.map((element, key) => {
                  return (
                    <tr key={key}>
                      <td>{element.allergyName}</td>
                      <td colSpan={2}>{element.reaction}</td>
                      <td>{element.status}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4}>
                    <div className="no-data">
                      <span>No data available</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Medications;
